// extracted by mini-css-extract-plugin
export default {"container":"Table_container__JOWCm","scrollBox":"Table_scrollBox__qab+H"};